import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdTransactionsApi, EdTransactionsView } from '../tokens/ed-transactions.token';

/**
 * REST implementation of the E-D Transactions API (PRD §3.7, EM-837).
 *
 *   GET /services/embedded/api/v1/ed/transactions?sme={id}
 *   GET /services/embedded/api/v1/ed/transactions/export?sme={id}
 *
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10). Bound to ED_TRANSACTIONS.
 */
@Injectable({ providedIn: 'root' })
export class EdTransactionsRestService implements EdTransactionsApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed/transactions`;

  getTransactions(smeId?: number | null): Observable<EdTransactionsView> {
    return this.http.get<EdTransactionsView>(this.base, { params: this.smeParams(smeId) });
  }

  exportTransactions(smeId?: number | null): Observable<Blob> {
    return this.http.get(`${this.base}/export`, { params: this.smeParams(smeId), responseType: 'blob' });
  }

  private smeParams(smeId?: number | null): HttpParams {
    let params = new HttpParams();
    if (smeId != null) params = params.set('sme', String(smeId));
    return params;
  }
}
